import { GetAccountResponseSchema, type GetAccountResponse } from '@vy/api-definition';
import { validateNotEmptyObject } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useAccountSuspense(options?: CustomUseQueryOptions<GetAccountResponse>) {
  const useAccountResponse = useAccount({ suspense: true, ...options });

  validateNotEmptyObject(useAccountResponse.data, 'useAccountSuspense');

  return useAccountResponse;
}

export function useAccount(options?: CustomUseQueryOptions<GetAccountResponse>) {
  return useQuery(
    queryKeys.account(),
    async () => {
      const api = getPrivateApi();
      const getAccountResponse = await api.getAccount();

      return GetAccountResponseSchema.parse(getAccountResponse);
    },
    options,
  );
}
